<template>
  <div class="history-museum">
    <div v-for="(item, index) in list" :key="index" class="item-div">
      <p class="year">{{item.year}}</p>
      <p class="title">{{item.title}}</p>

      <p class="content" v-html="item.content"></p>

      <ul class="desc-list">
        <li v-for="(desc, idx) in item.descList" :key="idx" >{{desc.text}}</li>
      </ul>

      <ClubImgSlider v-if="item.img.length > 1" :img-list="item.img" />
      <img v-else :src="imageSrc(item.img[0])" alt="">
    </div>
  </div>
</template>
<script>
import ClubImgSlider from '@/components/Club/ClubImgSlider.vue';

export default {
  name: 'HistoryMuseum',
  components: {ClubImgSlider},
  data() {
    return {
      list: []
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init() {
      this.list = [
        {
          year: '1990년대',
          title: '태동기',
          content: `광양, 여수, 순천, 여천 지역 연고를 기반하여 전남드래곤즈 프로축구단은 <span class="underline">1994년 12월 16일</span> 창단 하였다. 초대감독 故정병탁 감독을 선임하였고 창단 초기 광양축구전용구장은 연일 만원 사례를 이어 나갔다. 1997년 창단 <span class="bold">첫 FA컵 우승</span>과 <span class="bold">아디다스컵 준우승</span>을 일궈내며 명문구단의 초석을 다졌다. 또한 1999년 <span class="bold">아시안컵 위너스컵 준우승</span>을 만들어내면서 <span class="underline">토너먼트의 강자로 부상하였다.</span>`,
          descList: [
            { text: '1994년: 11월 1일 창립, 12월 16일 창단' },
            { text: '1995년: 노상래 득점왕 & 신인왕' },
            { text: '1997년 FA컵 우승' },
            { text: '1997년: 아디다스컵 준우승, 페어플레이 상' },
            { text: '1998년: FA컵 3위' },
            { text: '1999년: 프로축구 올해의 페어플레이팀, 아시안컵 위너스컵 준우승' },
          ],
          img: ['museum_01-1', 'museum_01-2', 'museum_01-3', 'museum_01-4']
        }, {
          year: '2000년대',
          title: '발전기',
          content: `전남드래곤즈는 스타플레이어 김태영, 김남일, 김도근, 신병호와 외국인 선수 세자르 등 의 활약을 앞세워 2000년대를 시작했다. 창단 멤버 김태영은 전남드래곤즈 소속 11시즌(1995~2005)을 함께한 원클럽맨으로 정규리그 통산 250경기를 출전하였다.
        <br>
        또한 전남드래곤즈는 K리그 최초 유소년 시스템을 도입하면서 한국축구의 발전을 선도했다.
        <br>
        2006, 2007 FA CUP 2년 연속 우승을 통해 토너먼트 강자로 자리매김한 전남드래곤즈는 정규 리그 성적 4위를 기록하는 등 한국축구를 노란물결로 물들게 하였다.`,
          descList: [
            { text: '2000년: 대한화재컵 준우승, 아디다스컵 공동 3위' },
            { text: '2003년: FA컵 준우승, 페어플레이상, 광양제철중 전국대회 2관왕, 광양제철남초 동원컵 왕중왕전 우승' },
            { text: '2004년: 통영컵 우승' },
            { text: '2006년: FA컵 우승, 올해의 프로축구대상 특별상' },
            { text: '2007년: FA컵 우승(사상 최초 2연패)' },
            { text: '2008년: 드래곤즈 유스클럽 윈저 어워드, 삼성 하우젠컵 준우승' },
          ],
          img: ['museum_02-1', 'museum_02-2', 'museum_02-3']
        }, {
          year: '2010년대',
          title: '화수분',
          content: `2010년대는 유소년 육성 시스템이 빛을 본 시기이다. ‘추자도 소년’ 지동원(전남드래곤즈 유소년 시스템 최초 EPL, 선더랜드 이적), 윤석영(EPL, 퀸즈파크 레인저스FC 이적) , 이종호(2014 인천 아시안게 임 축구대표팀 금메달), 김영욱(2014 인천 아시안게임 축구대표팀 금메달) 등 전남드래곤즈 유소년 시스템이 한국축구의 화수분 역할을 도맡았다.`,
          descList: [
            { text: '2011년: 광양제철고 전국고교축구선수권대회 우승' },
            { text: '2015년: 광양제철고 전국대회 2관왕, 광양제철중 춘계중등연맹전 우승' },
            { text: '2016년: K리그 사회공헌상 대상 수상' },
            { text: '2017년: 광양제철중 추계중등축구연맹전 우승' },
            { text: '2018년: K리그 어워즈 2018 사랑나눔상 수상' },
          ],
          img: ['museum_03-1', 'museum_03-2', 'museum_03-3']
        }, {
          year: '2020년대',
          title: '성장기',
          content: `승강제 제도가 시행된 후 2018년 K리그2로 강등된 전남드래곤즈는 성장기를 겪고 있다. 2021년 K리그2 준PO 진출 그리고 FA CUP 우승을 달성하였고 K리그2 팀 최초로 2022 AFC 챔피언스리그에 참가했다. 또한 한국프로축구연맹 주관 그린스타디움상을 연속 수상하는 등 끊임없이 도전하고 노력하고 있다.`,
          descList: [
            { text: '2020년: K리그 2020 그린스타디움상 대상 수상' },
            { text: '2021년: FA CUP 우승(MVP 정재희, 득점왕 박희성)' },
            { text: '2021년: 제 1,2차 그린스타디움상 수상' },
          ],
          img: ['museum_04-1']
        }
      ]
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/club/history/'+imgSrc+'.png');
    },
  }
}
</script>
